// ABOUTME: Content of a family card in the treeview catalog: its title with the favorite star, then its image.
// ABOUTME: Fills the model-selection family card's OverrideContent slot.

import type { IFamilyCardContentProps } from '@coolshop/cool-model-selection';
import { Stack, Typography } from '@ds/coolshop';

import { CatalogThumbnail } from './CatalogThumbnail';
import { CategoryFavoriteAction } from './CategoryFavoriteAction';
import { getProductImageUrl } from './getProductImageUrl';

export function CatalogFamilyCardContent({ category, title }: IFamilyCardContentProps) {
    return (
        <Stack gap={2} height="100%" data-testid="catalog-family-card">
            <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
                <Typography variant="subtitle2">{title}</Typography>
                <CategoryFavoriteAction category={category} />
            </Stack>
            <CatalogThumbnail url={getProductImageUrl(category)} alt={title} />
        </Stack>
    );
}
